import styled from "styled-components";
import { Row } from "../../../../components/flex/styled";

export const EmployerProfileWrapper = styled("div")(() => {
  return {
    backgroundColor: "#fafafa",
    borderRadius: "1rem",
    padding: "var(--cardPadding) 0",
    overflow: "hidden",
    minHeight: "100vh",
    "& input, & select, & textarea": {
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) / 2)",
      outline: "none",
      backgroundColor: "var(--color-button-secondary)",
      border: "1px solid var(--color-primary-hover)",
      borderRadius: ".5rem",
      fontWeight: "400",
    },
    "& label": {
      fontFamily: "Poppins",
      fontWeight: 500,
      color: "var(--color-text)",
      marginBlockEnd: "calc(var(--sectionMargin)/5)",
    },
    "& fieldset": {
      flex: 1,
      overflow: "hidden",
      display: "flex",
      gap: "calc(var(--flexGap)/8)",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    "& .employer-profile-submit-button-box": {
      paddingTop: "var(--cardPadding)",
      overflow: "hidden",
    },
    "& .company-profile-submit-button-box": {
      paddingTop: "calc(var(--cardPadding)/2)",
      overflow: "hidden",
      "@media screen and (min-width: 768px)": {
        marginLeft: "auto",
      },
    },
    "& .payment-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#FFFFFF",
      padding: "calc(var(--cardPadding))",
      borderRadius: "1rem",
      boxShadow: "0px 20px 24px -4px #10182814",
      "& .payment-form": {
        alignItems: "unset",
        justifyContent: "unset",
        padding: "unset",
      },
      "@media screen and (max-width: 425px)": {
        top: "50%",
        left: "50%",
        right: 0,
        bottom: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "1rem",
        width: "85%",
      },
    },
    "& .employer-headshot": {
      width: "100%",
      height: "auto",
      borderRadius: "50%",
      "@media screen and (min-width: 280px)": {
        width: "150px",
        height: "150px",
      },
    },
    "& .employer-profile-image-area": {
      padding: "0 0 var(--cardPadding) 0",
      margin: "0 0 var(--cardPadding) 0",
      borderBottom: "4px solid var(--color-primary-hover)",
      "& .employer-profile-image-action-area": {
        alignItems: "center",
        overflow: "hidden",
        "& .edit-icon": {
          position: "relative",
          top: "-3.5rem",
          left: "-1rem",
          cursor: "pointer",
        },
        "@media screen and (min-width: 768px)": {
          flexDirection: "row",
        },
      },
    },
    "& form": {
      display: "flex",
      flexDirection: "column",
      gap: "calc(var(--flexGap) * 1.5)",
      overflow: "hidden",
    },
    "& .tab-area": {
      position: "absolute",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "var(--color-button-secondary-hover)",
      borderRadius: "5px",
      zIndex: 1,
      gap: 0,
      "& .tab": {
        cursor: "pointer",
        overflow: "hidden",
        userSelect: "none",
        transition: "background-color 0.3s",
        "& h2": {
          marginBlock: 0,
          fontWeight: 500,
          fontSize: "24px",
          color: "var(--color-text-light)",
          "@media screen and (max-width: 768px)": {
            fontSize: "16px",
          },
        },
      },
      "@media screen and (max-width: 1024px)": {
        top: "8.125rem",
        "& .tab": {
          padding: "calc(var(--cardPadding)/4) calc(var(--cardPadding)/2)",
        },
      },
      "@media screen and (min-width: 769px) and (max-width: 1023px)": {
        top: "9.125rem",
        "& .tab": {
          padding: "calc(var(--cardPadding)/4) calc(var(--cardPadding)* 2)",
        },
      },
      "@media screen and (min-width: 1024px)": {
        top: "10px",
        "& .tab": {
          padding: "calc(var(--cardPadding)/4) calc(var(--cardPadding)* 2)",
        },
      },
      "@media screen and (max-width: 363px)": {
        position: "relative",
        top: 0,
        overflow: "hidden",
      },
    },
    "& .upper-section-company-details": {
      padding: "var(--cardPadding) 0",
      borderBottom: "4px solid var(--color-primary-hover)",
      display: "flex",
      flexDirection: "column",
      "& form": {
        display: "flex",
        gap: "calc(var(--flexGap) * 1)",
        flexDirection: "column",
        "& label": {
          whiteSpace: "nowrap",
        },
        "& .company-logo-wrapper": {
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        },
        "& .company-logo": {
          width: "100%",
          height: "auto",
          borderRadius: "50%",
        },
        "& .edit-icon": {
          position: "absolute",
          right: "-0.75rem",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          zIndex: 2,
        },
        "@media screen and (min-width: 768px)": {
          flexDirection: "row",
          alignItems: "center",
          "& .edit-icon": {
            right: "-0.75rem",
            top: "50%",
            transform: "translateY(-50%)",
          },
        },
        "@media screen and (min-width: 280px)": {
          "& .company-logo": {
            width: "150px",
            height: "150px",
          },
        },
      },
      "& .payroll-plan": {
        display: "flex",
        justifyContent: "flex-end",
        gap: "1rem",
        alignItems: "center",
        "& p": {
          fontWeight: 500,
          marginBlock: 0,
        },
        "@media screen and (max-width: 600px)": {
          justifyContent: "space-between",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "calc(var(--flexGap)/4)",
          overflow: "hidden",
        },
      },
      "& .small-select": {
        width: "150px",
        height: "32px",
        fontSize: "14px",
        padding: "4px 8px",
        backgroundColor: "var(--color-button-secondary)",
        "@media screen and (max-width: 600px)": {
          width: "100%",
        },
      },
      "@media screen and (max-width: 600px)": {
        gap: "calc(var(--flexGap) / 2)",
      },
    },
    "& .lower-section-company-details": {
      padding: "2rem 0",
      display: "flex",
      flexDirection: "column",
      gap: "1.5rem",
      "& span": {
        fontWeight: 500,
        color: "var(--color-text)",
      },
      "@media screen and (max-width: 1024px)": {
        "& .cardRow": {
          gap: 0,
        },
      },
    },
  };
});

export const ProfileRow = styled(Row)(() => {
  return {
    justifyContent: "space-between",
    "@media screen and (max-width: 768px)": {
      gap: "calc(var(--flexGap)*1.5)",
      flexDirection: "column",
    },
  };
});
